export * from "./CompetitorElement";
